import { createAction, props } from '@ngrx/store';
import { CombinedLongeingData, LongeingDirectionType, Recording, RecordingActionSuccessTypeEnum } from '@sleipai/sleip-models';
import { RecordingUpdate } from '@sleipai/sleip-models';
import { QueryConfig } from '../../helpers';

export const loadRecordings = createAction('[Recording] Load Recordings');

export const loadSingleRecording = createAction(
  '[Recording] Load Single Recording',
  props<{ id: string }>()
);

export const addSingleRecording = createAction(
  '[Recording] Add Single Recording',
  props<{ recording: any }>()
);

export const addRecordings = createAction(
  '[Recording] Add Recordings',
  props<{ recordings: Recording[] | Partial<Recording>[]; hasMore: boolean }>()
);

export const loadRecordingsByIds = createAction(
  '[Recording] Load Recordings By Recording Ids',
  props<{ recordingIds: string[] }>()
);

export const loadRecordingListByType = createAction(
  '[Recording] Load Recording List By Type',
  props<{ status: string; dbStatus: string; offset?: any }>()
);

export const loadRecordingListByTypeSuccess = createAction(
  '[Recording] Load Recording List By Type Success',
  props<{ recordings: Recording[] }>()
);

export const loadRecordingsCountInFirestoreDb = createAction(
  '[Recording] Load Recordings Count In Firestore DB',
  props<{ horseId?: string; filterMap?: Map<string, unknown> }>()
);

export const loadRecordingsListInFirestoreDb = createAction(
  '[Recording] Load Recordings List In Firestore DB',
  props<{
    queryConfig: QueryConfig;
    horseId?: string;
  }>()
);

export const loadRecordingsCountInFirestoreDbSuccess = createAction(
  '[Recording] Load Recordings Count In Firestore DB Success',
  props<{ count: number }>()
);

export const loadRecordingsListInFirestoreDbSuccess = createAction(
  '[Recording] Load Recordings List In Firestore DB Success',
  props<{ data: Recording[] }>()
);

export const loadRecordingsFailure = createAction(
  '[Recording] Load Recordings Failure',
  props<{ error: any }>()
);

export const removeRecording = createAction(
  '[Recording] Remove Recording',
  props<{ recordingId: string }>()
);

export const removeRecordingSuccess = createAction(
  '[Recording] Remove Recording Success',
  props<{ recordingId: string }>()
);

export const removeRecordingFailure = createAction(
  '[Recording] Remove Recording Failure',
  props<{ error: any }>()
);

export const resetRemoveRecordingFlag = createAction(
  '[Recording] Reset Remove Recording Flag'
);

// Infinite recording list pagination actions start
export const loadRecordingsInfiniteScrollListPageForHorse = createAction(
  '[Recording] Load Recordings Infinite Scroll List Page For Horse',
  props<{
    horseId: string;
    queryConfig: QueryConfig;
  }>()
);

export const loadRecordingsInfiniteScrollListPageForHorseSuccess = createAction(
  '[Recording] Load Recordings Infinite Scroll List Page Success',
  props<{
    recordingList: Recording[];
  }>()
);
//// Dashboard 2.0 recordings list pagination start ////
export const loadRecordingsListForInfiniteScrollInDashBoard = createAction(
  '[Recording] Load Recordings List Infinite Scroll In Dashboard',
  props<{
    reset: boolean;
    queryConfig: QueryConfig;
  }>()
);

export const loadRecordingsListForInfiniteScrollInDashBoardSuccess =
  createAction(
    '[Recording] Load Recordings List Infinite Scroll In Dashboard Success',
    props<{
      recordings: Recording[];
      hasMore: boolean;
    }>()
  );

export const loadRecordingsCountForInfiniteScrollInDashBoard = createAction(
  '[Recording] Load Recordings Count for Infinite Scroll In Dashboard',
  props<{
    reset: boolean;
    queryConfig: QueryConfig;
  }>()
);

export const loadRecordingsCountForInfiniteScrollInDashBoardSuccess =
  createAction(
    '[Recording] Load Recordings Count for Infinite Scroll In Dashboard Success',
    props<{
      recordingsCount: number;
    }>()
  );

export const resetRecordingsForInfiniteScrollInDashBoard = createAction(
  '[Recording] Reset Recordings For InfiniteScroll In DashBoard'
);

export const retryLoadRecordingsForInfiniteScrollInDashBoard = createAction(
  '[Recording] Retry Load Recordings ForInfiniteScroll In DashBoard',
  props<{ queryConfig: QueryConfig }>()
);
//// Dashboard 2.0 recordings list pagination end ////

// Infinite recording list pagination actions end

export const updateRecordingData = createAction(
  '[Recording] Update Recording data',
  props<{ updatedRecordingData: RecordingUpdate }>()
);

export const updateRecordingDataSuccess = createAction(
  '[Recording] Update Recording data Success'
);

export const resetRecordingUpdatedFlag = createAction(
  '[Recording] Reset Update Recording Flag'
);

export const updateRecordingDataFailure = createAction(
  '[Recording] Update Recording data Failure',
  props<{ error: any }>()
);

export const loadEligibleRecordingsToLinkForARecording = createAction(
  '[Recording] Load Eligible Recordings To Link For A Recording',
  props<{
    horseId: string;
    recordingId: string;
    creationDate: Date;
    longeingDirection: LongeingDirectionType;
  }>()
);

export const loadEligibleRecordingsToLinkForCombinedViewForRecordingSuccess =
  createAction(
    '[Recording] Load Eligible Recordings To Link For A Recording Success',
    props<{ recordings: Recording[] }>()
  );

export const batchRemoveRecordings = createAction(
  '[Recording] Batch Remove Recordings',
  props<{ recordingIds: string[] }>()
);

export const batchRemoveRecordingsSuccess = createAction(
  '[Recording] Batch Remove Recordings Success',
  props<{ removedIds: string[]; failedIds: string[]; recordingActionSuccessType: RecordingActionSuccessTypeEnum }>()
);

export const batchRemoveRecordingsFailure = createAction(
  '[Recording] Batch Remove Recordings Failure',
  props<{ error: any }>()
);

export const batchMoveRecordingsToHorse = createAction(
  '[Recording] Batch Move Recordings To Horse',
  props<{ recordingIds: string[]; horseId: string }>()
);

export const batchMoveRecordingsToHorseSuccess = createAction(
  '[Recording] Batch Move Recordings To Horse Success',
  props<{ movedIds: string[]; failedIds: string[]; recordingActionSuccessType: RecordingActionSuccessTypeEnum }>()
);

export const batchMoveRecordingsToHorseFailure = createAction(
  '[Recording] Batch Move Recordings To Horse Failure',
  props<{ error: any }>()
);

export const updateCombinedViewLinkedRecording = createAction(
  '[Recording] Update Combined View Linked Recording',
  props<{
    selectedRecordingId: string;
    newLinkedRecordingId: string | null;
    previousLinkedRecordingId: string | null;
  }>()
);

export const recordingLinkingForCombinedViewRelatedOperationFailure =
  createAction(
    '[Recording] Recording Linking For Combined View Related Operation Failure',
    props<{ error: any }>()
  );

export const loadCombinedLongeingsForHorse = createAction(
  '[Recording] Load Combined Longeings For Horse',
  props<{ horseId: string }>()
);

export const setCombinedLongeingsForHorse = createAction(
  '[Recording] Set Combined Longeings For Horse',
  props<{ combinedLongeings: CombinedLongeingData[] }>()
);

export const loadCombinedLongeingsForHorseFailure = createAction(
  '[Recording] Load Combined Longeings For Horse Failure',
  props<{ error: any }>()
);

export const clearCombinedLongeings = createAction(
  '[Recording] Clear Combined Longeings'
);
